/**
 * Route `/` — Public Landingpage (W4.2)
 *
 * Eingeloggte User → Redirect zu /dashboard
 * Nicht-eingeloggte User → LandingPage-Komponente
 */
import { createFileRoute, redirect } from '@tanstack/react-router'
import { useAuthStore } from '../stores/authStore'
import { LandingPage } from '../features/landing/LandingPage'

export const Route = createFileRoute('/')({
  beforeLoad: () => {
    if (useAuthStore.getState().isAuthenticated) {
      throw redirect({ to: '/dashboard' })
    }
  },
  component: LandingPage,
})
